import React, { FC } from 'react'

export const ChatIcon: FC<React.SVGProps<SVGSVGElement>> = React.memo(
  ({ width = 24, height = 24, fill = '#000', ...props }) => (
    <svg width={width} height={height} {...props} viewBox='0 0 24 24'>
      <path
        d='M12.737 0C6.436 0 1.475 5.039 1.475 11.27c0 1.99.536 3.846 1.475 5.437L0 24l7.24-2.917c1.61.796 3.486 1.326 5.497 1.326C19.04 22.409 24 17.37 24 11.27 24 5.039 19.04 0 12.737 0zm0 20.95c-1.608 0-3.352-.398-4.692-1.193l-.67-.398-.671.265-4.022 1.591 1.608-3.977.269-.663-.403-.663A9.591 9.591 0 012.95 11.27c0-5.304 4.424-9.68 9.787-9.68 5.364 0 9.788 4.376 9.788 9.68 0 5.304-4.424 9.68-9.788 9.68z'
        fill={fill}
      />
    </svg>
  )
)
